import React from 'react'

const Language = () => {
	return (
		<div className='py-2 container-fluid'>
			<div className='card p-2 border-radius-2xl bg-lite-gray mb-3 mt-1'>
				<div className='d-flex justify-content-between align-items-baseline'>
					<div>
						<div class='form-check'>
							<input class='form-check-input mt-2' type='checkbox' name='flexRadioDefault' id='customRadio1' />
							<b class='ms-2 fs-5 text-black fw-light'>English</b>
						</div>
					</div>
					<div>
						<img src='../../assets/img/languages/english.png' height='70' width='100' alt='' />
					</div>
				</div>
			</div>
			<div className='card p-3 border-radius-2xl bg-lite-gray mb-3 mt-1'>
				<div className='d-flex justify-content-between align-items-center'>
					<div>
						<div class='form-check'>
							<input class='form-check-input mt-2' type='checkbox' name='flexRadioDefault' id='customRadio1' />
							<b class='ms-2 fs-5 text-black fw-light'>Hindi</b>
						</div>
					</div>
					<div>
						<img src='../../assets/img/languages/hindi.png' height='70' width='100' alt='' />
					</div>
				</div>
			</div>
			<div className='card p-3 border-radius-2xl bg-lite-gray mb-3 mt-1'>
				<div className='d-flex justify-content-between align-items-center'>
					<div>
						<div class='form-check'>
							<input class='form-check-input mt-2' type='checkbox' name='flexRadioDefault' id='customRadio1' />
							<b class='ms-2 fs-5 text-black fw-light'>Telugu</b>
						</div>
					</div>
					<div>
						<img src='../../assets/img/languages/telugu.png' height='70' width='100' alt='' />
					</div>
				</div>
			</div>
			<div className='card p-3 border-radius-2xl bg-lite-gray mb-3 mt-1'>
				<div className='d-flex justify-content-between align-items-center'>
					<div>
						<div class='form-check'>
							<input class='form-check-input mt-2' type='checkbox' name='flexRadioDefault' id='customRadio1' />
							<b class='ms-2 fs-5 text-black fw-light'>Tamil</b>
						</div>
					</div>
					<div>
						<img src='../../assets/img/languages/tamil.png' height='70' width='100' alt='' />
					</div>
				</div>
			</div>
			<div className='card p-3 border-radius-2xl bg-lite-gray mb-3 mt-1'>
				<div className='d-flex justify-content-between align-items-center'>
					<div>
						<div class='form-check'>
							<input class='form-check-input mt-2' type='checkbox' name='flexRadioDefault' id='customRadio1' />
							<b class='ms-2 fs-5 text-black fw-light'>Kannada</b>
						</div>
					</div>
					<div>
						<img src='../../assets/img/languages/kannada.png' height='70' width='100' alt='' />
					</div>
				</div>
			</div>
		</div>
	)
}

export default Language
